export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_02.bcc8c1c0.jpg";